import { ChevronLeft } from '@mui/icons-material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button } from '@ovComponents/2-component/button/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { NetWorthWorkflowContext } from '@ovComponents/4-module/netWorthWorkflow/netWorthWorkflowContext';
import { WorkflowContext } from '@ovComponents/4-module/workflowCompletion/workflowCompletionContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import NetWorthAutomaticLink from './netWorthAutomaticLink';
import NetWorthIntegrationLink from './netWorthIntegrationLink';

const AddNetWorthAutomaticallyModal = ({
  open,
  onClose,
  step,
  setStep,
  onNext,
  workflowCompletion,
  subStepId,
}: {
  open: boolean;
  onClose: () => void;
  step: number;
  setStep: (step: number) => void;
  onNext: () => void;
  workflowCompletion: any;
  subStepId: string;
}) => {
  const { t } = useTranslation('shared');
  const { netWorthData, setNetWorthData } = useContext(NetWorthWorkflowContext);
  const { workflowData, setWorkflowData } = useContext(WorkflowContext);

  const applicableData =
    Object.keys(netWorthData).length !== 0 ? netWorthData : workflowData;
  const setApplicationContext =
    Object.keys(netWorthData).length !== 0 ? setNetWorthData : setWorkflowData;

  const goBack = () => {
    setApplicationContext({
      ...applicableData,
      netWorthData: {
        ...applicableData.netWorthData,
        netWorthStep: 1,
      },
    });
    setStep(1);
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        borderBottom='none'
        display='flex'
        justifyContent={step === 2 ? 'space-between' : 'end'}
      >
        {step === 2 && (
          <Button
            variant='text'
            label={t('back')}
            leadingIcon={ChevronLeft}
            onClick={goBack}
            sx={{ paddingX: 2 }}
          />
        )}
        <IconButton onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: '20px',
          height: '550px',
          width: '550px',
        }}
      >
        {step === 1 && <NetWorthIntegrationLink onNext={() => setStep(2)} />}
        {step === 2 && (
          <NetWorthAutomaticLink
            onNext={() => {
              onNext();
              onClose();
            }}
            workflowCompletion={workflowCompletion}
            subStepId={subStepId}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddNetWorthAutomaticallyModal;
